// extracted by mini-css-extract-plugin
export default {"container":"TableFilterCollapse__container___IKVUq"};